import React from 'react';
import PropTypes from 'prop-types';
import { FEATURE_KEYS } from '@medflex/utils/subscriptionEnums';
import SessionChatModule from '../SessionChatModule';
import useFeatures from '../../hooks/useFeatures';

const ActivitiesPamChat = ({ id }) => {
  const [chatCharacters] = useFeatures([FEATURE_KEYS.CHAT_CHARACTERS]);

  return <SessionChatModule id={id} chatCharacters={chatCharacters} />;
};

ActivitiesPamChat.propTypes = {
  id: PropTypes.string.isRequired,
};

export default ActivitiesPamChat;
